import { render, staticRenderFns } from "./RolesByMenu.vue?vue&type=template&id=773cb5c4&scoped=true"
import script from "./RolesByMenu.vue?vue&type=script&lang=js"
export * from "./RolesByMenu.vue?vue&type=script&lang=js"
import style0 from "./RolesByMenu.vue?vue&type=style&index=0&id=773cb5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cb5c4",
  null
  
)

export default component.exports